import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
export default function UIMediaLeft(props) {
  const {
    className
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    className: classNames("private-media__item private-media__item--left", className)
  }));
}
UIMediaLeft.displayName = 'UIMediaLeft';
UIMediaLeft.propTypes = {
  children: PropTypes.node
};